import { GetCustomerClaimsResponse } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from '../axios';

export const getClaims = async (): Promise<GetCustomerClaimsResponse> => {
  const { data } = await axios.get<GetCustomerClaimsResponse>(
    `${import.meta.env.VITE_CUSTOMERS_API_URL}/v1/customers/claims`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 404,
    }
  );

  return data;
};

export const useClaimsQuery = (enabled: boolean = true) =>
  useQuery({
    queryKey: ['claims'],
    queryFn: () => getClaims(),
    staleTime: 1000 * 60 * 3,
    retry: 1,
    enabled,
  });
